import Vue from 'vue';
import {api} from '../resources'

export default {
    namespaced: true,
    state: {
        current_space_members: [],
    },
    getters: {},
    actions: {
        async fetchSpaceMembers({commit, rootState}) {
            try {
                const space_id = rootState.space.current_space.data.id;
                const res = await api.space_members.get({space_id});
                if (res.body.success) {
                    commit('setSpaceMembers', res.body.data.rows)
                }
            } catch (err) {
                console.error(err)
            }
        },
        sendInvite({}, data) {
            return api.invitations.save(data);
        },
        deleteInvite({}, id) {
            return api.invitations.delete({id}, {});
        },
        resendInvite({}, id) {
            return api.invitations_resend.save({id});
        },
        unlinkUserFromSpace({}, user_id) {
            return api.space_unlink_user.save({user_id}, {})
        },
        updateUserRole({}, {user_id, ...data}) {
            return api.space_update_user_role.save({user_id}, data)
        }
    },
    mutations: {
        setSpaceMembers(state, data) {
            state.current_space_members = data;
        },
        setUserRole(state, {user_id, role}) {
            let userIndex = state.current_space_members.findIndex(user => user.id === user_id),
                updatedUser = state.current_space_members[userIndex];
            updatedUser.role = +role;
            Vue.set(state.current_space_members, userIndex, updatedUser);
        },
        clearSpaceMembers(state){
            state.current_space_members=[];
        }
    }
}
